import React from 'react';
import ComponentField from "../../form/ComponentField";
import DateTimeInput from '../../form/DateTimeInput';
import createForm from './Form';

class TimeConfigExceptionForm extends React.Component {

    render() {
        const filterProps = {
            name: "filter",
            value: typeof this.props.values.filter === "string" ? JSON.parse(this.props.values.filter) : this.props.values.filter,
            saveChanges: this.props.setFieldValue
        };
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-sm-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("from")}
                            name="from"
                            value={this.props.values.from}
                            label="Kezdet"
                            showTime={true}
                            maxDate={this.props.values.to}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("to")}
                            name="to"
                            value={this.props.values.to}
                            label="Vég"
                            showTime={true}
                            minDate={this.props.values.from}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="program"
                            isClearable={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            disabled={!!this.props.values.location}
                            label="Program"
                        />
                    </div>
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="location"
                            isClearable={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            disabled={!!this.props.values.program}
                            label="Helyszín"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TimeConfigExceptionForm);
